import { useMatch } from "react-router-dom";
import { useMemo } from "react";
import { isGlobalUserLoggedIn } from "../utils/jwt";

const useHideCart = () => {
  const login = useMatch("/login");
  const forgotPassword = useMatch("/forgot-password");
  const registerRetail = useMatch("/register-retail");
  const expressCheckout = useMatch("/register-express-retail");
  const isGlobalUser = isGlobalUserLoggedIn();

  const shouldHide = useMemo(() => {
    return login || forgotPassword || registerRetail || expressCheckout || isGlobalUser;
  }, [login, forgotPassword, registerRetail, expressCheckout, isGlobalUser]);

  return shouldHide;
};

export default useHideCart;
